export default __webpack_public_path__ + "2022 Semi-empirical quantum optics for mid-infrared molecular nanophotonics.pdf";